import { Input } from 'antd';
import React, { useCallback } from 'react';

type InputProps = Omit<React.ComponentProps<typeof Input>, 'onChange'>;

interface TextFormGroupProps {
    label: string;
    onChange(value: string): void;
}

const TextFormGroup: React.FC<TextFormGroupProps & InputProps> = ({ label, value, onChange, ...inputProps }) => {
    const onChangeHandler = useCallback(({ target }: React.ChangeEvent<HTMLInputElement>) => onChange(target.value), [onChange]);

    return (
        <>
            <div style={{ gridColumn: 1 }}>
                <strong>{label}:</strong>
            </div>
            <div style={{ gridColumn: '2/6' }}>
                <Input onChange={onChangeHandler} value={value} {...inputProps} />
            </div>
        </>
    );
};

export default React.memo(TextFormGroup);
